/* tslint:disable */
/* eslint-disable */
/**
 * TOM PLANNING SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { AssignRailcarTrackPositionCommand } from '../model'
// @ts-ignore
import type { CancelRailVisitCommand } from '../model'
// @ts-ignore
import type { CargoType } from '../model'
// @ts-ignore
import type { CarrierVisitStatus } from '../model'
// @ts-ignore
import type { CheckLoadPreparationCommand } from '../model'
// @ts-ignore
import type { CheckRailcarForDischargeCommand } from '../model'
// @ts-ignore
import type { CreateDepartureCheckRailcarCommand } from '../model'
// @ts-ignore
import type { CreateRailVisitCommand } from '../model'
// @ts-ignore
import type { CreateRailcarAndOrdersCommand } from '../model'
// @ts-ignore
import type { CreateRailcarTrackPositionCommand } from '../model'
// @ts-ignore
import type { DeleteRailcarTrackPositionCommand } from '../model'
// @ts-ignore
import type { RailVisitResponseDto } from '../model'
// @ts-ignore
import type { RailVisitResponseDtoPaginatedList } from '../model'
// @ts-ignore
import type { ReactivateRailVisitCommand } from '../model'
// @ts-ignore
import type { ReportRailcarTrackPositionMissingCommand } from '../model'
// @ts-ignore
import type { RevertCurrentStatusCommand } from '../model'
// @ts-ignore
import type { UpdateRailVisitCommand } from '../model'
// @ts-ignore
import type { UpdateRailVisitStatusCommand } from '../model'
// @ts-ignore
import type { UpdateRailcarSequenceCommand } from '../model'
/**
 * RailVisitsApi - axios parameter creator
 */
export const RailVisitsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {AssignRailcarTrackPositionCommand} [assignRailcarTrackPositionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignRailcarTrackPosition: async (
      assignRailcarTrackPositionCommand?: AssignRailcarTrackPositionCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/AssignRailcarTrackPosition`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        assignRailcarTrackPositionCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CancelRailVisitCommand} [cancelRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancel: async (
      cancelRailVisitCommand?: CancelRailVisitCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/Cancel`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        cancelRailVisitCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CheckLoadPreparationCommand} [checkLoadPreparationCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkLoadPreparation: async (
      checkLoadPreparationCommand?: CheckLoadPreparationCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/CheckLoadPreparation`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkLoadPreparationCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CheckRailcarForDischargeCommand} [checkRailcarForDischargeCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkRailcarForDischarge: async (
      checkRailcarForDischargeCommand?: CheckRailcarForDischargeCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/CheckRailcarForDischarge`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        checkRailcarForDischargeCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateRailVisitCommand} [createRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create: async (
      createRailVisitCommand?: CreateRailVisitCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRailVisitCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateRailcarAndOrdersCommand} [createRailcarAndOrdersCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRailcarAndOrders: async (
      createRailcarAndOrdersCommand?: CreateRailcarAndOrdersCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/CreateRailcarAndOrders`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRailcarAndOrdersCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateRailcarTrackPositionCommand} [createRailcarTrackPositionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRailcarTrackPosition: async (
      createRailcarTrackPositionCommand?: CreateRailcarTrackPositionCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/CreateRailcarTrackPosition`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createRailcarTrackPositionCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {DeleteRailcarTrackPositionCommand} [deleteRailcarTrackPositionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRailcarTrackPosition: async (
      deleteRailcarTrackPositionCommand?: DeleteRailcarTrackPositionCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/DeleteRailcarTrackPosition`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        deleteRailcarTrackPositionCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateDepartureCheckRailcarCommand} [createDepartureCheckRailcarCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    departureCheck: async (
      createDepartureCheckRailcarCommand?: CreateDepartureCheckRailcarCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/DepartureCheck`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createDepartureCheckRailcarCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} page
     * @param {number} pageSize
     * @param {Array<CarrierVisitStatus>} [statuses]
     * @param {CargoType} [cargoType]
     * @param {boolean} [includeAtaDateRangeFilter]
     * @param {string} [filter]
     * @param {boolean} [includeCompleted]
     * @param {string} [orderBy]
     * @param {boolean} [isDescending]
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (
      page: number,
      pageSize: number,
      statuses?: Array<CarrierVisitStatus>,
      cargoType?: CargoType,
      includeAtaDateRangeFilter?: boolean,
      filter?: string,
      includeCompleted?: boolean,
      orderBy?: string,
      isDescending?: boolean,
      from?: string,
      to?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'page' is not null or undefined
      assertParamExists('get', 'page', page)
      // verify required parameter 'pageSize' is not null or undefined
      assertParamExists('get', 'pageSize', pageSize)
      const localVarPath = `/planning/api/RailVisits`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (statuses) {
        localVarQueryParameter['Statuses'] = statuses
      }

      if (cargoType !== undefined) {
        localVarQueryParameter['CargoType'] = cargoType
      }

      if (includeAtaDateRangeFilter !== undefined) {
        localVarQueryParameter['IncludeAtaDateRangeFilter'] = includeAtaDateRangeFilter
      }

      if (page !== undefined) {
        localVarQueryParameter['Page'] = page
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['PageSize'] = pageSize
      }

      if (filter !== undefined) {
        localVarQueryParameter['Filter'] = filter
      }

      if (includeCompleted !== undefined) {
        localVarQueryParameter['IncludeCompleted'] = includeCompleted
      }

      if (orderBy !== undefined) {
        localVarQueryParameter['OrderBy'] = orderBy
      }

      if (isDescending !== undefined) {
        localVarQueryParameter['IsDescending'] = isDescending
      }

      if (from !== undefined) {
        localVarQueryParameter['From'] =
          (from as any) instanceof Date ? (from as any).toISOString() : from
      }

      if (to !== undefined) {
        localVarQueryParameter['To'] = (to as any) instanceof Date ? (to as any).toISOString() : to
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getById', 'id', id)
      const localVarPath = `/planning/api/RailVisits/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getByIds: async (
      ids: Array<number>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'ids' is not null or undefined
      assertParamExists('getByIds', 'ids', ids)
      const localVarPath = `/planning/api/RailVisits/GetByIds`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (ids) {
        localVarQueryParameter['Ids'] = ids
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [railVisitId]
     * @param {string} [name]
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOverlapping: async (
      railVisitId?: number,
      name?: string,
      from?: string,
      to?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/GetOverlapping`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (railVisitId !== undefined) {
        localVarQueryParameter['RailVisitId'] = railVisitId
      }

      if (name !== undefined) {
        localVarQueryParameter['Name'] = name
      }

      if (from !== undefined) {
        localVarQueryParameter['From'] =
          (from as any) instanceof Date ? (from as any).toISOString() : from
      }

      if (to !== undefined) {
        localVarQueryParameter['To'] = (to as any) instanceof Date ? (to as any).toISOString() : to
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateRailVisitCommand} [updateRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    put: async (
      updateRailVisitCommand?: UpdateRailVisitCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRailVisitCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {ReactivateRailVisitCommand} [reactivateRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reactivate: async (
      reactivateRailVisitCommand?: ReactivateRailVisitCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/Reactivate`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        reactivateRailVisitCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {ReportRailcarTrackPositionMissingCommand} [reportRailcarTrackPositionMissingCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportMissingRailcar: async (
      reportRailcarTrackPositionMissingCommand?: ReportRailcarTrackPositionMissingCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/ReportMissingRailcar`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        reportRailcarTrackPositionMissingCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} id
     * @param {RevertCurrentStatusCommand} [revertCurrentStatusCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revertCurrentStatus: async (
      id: number,
      revertCurrentStatusCommand?: RevertCurrentStatusCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('revertCurrentStatus', 'id', id)
      const localVarPath = `/planning/api/RailVisits/{id}/RevertCurrentStatus`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        revertCurrentStatusCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} id
     * @param {UpdateRailVisitStatusCommand} [updateRailVisitStatusCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRailVisitStatus: async (
      id: number,
      updateRailVisitStatusCommand?: UpdateRailVisitStatusCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('updateRailVisitStatus', 'id', id)
      const localVarPath = `/planning/api/RailVisits/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRailVisitStatusCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateRailcarSequenceCommand} [updateRailcarSequenceCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRailcarSequence: async (
      updateRailcarSequenceCommand?: UpdateRailcarSequenceCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/planning/api/RailVisits/UpdateRailcarSequence`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateRailcarSequenceCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RailVisitsApi - functional programming interface
 */
export const RailVisitsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RailVisitsApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {AssignRailcarTrackPositionCommand} [assignRailcarTrackPositionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async assignRailcarTrackPosition(
      assignRailcarTrackPositionCommand?: AssignRailcarTrackPositionCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.assignRailcarTrackPosition(
        assignRailcarTrackPositionCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.assignRailcarTrackPosition']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CancelRailVisitCommand} [cancelRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async cancel(
      cancelRailVisitCommand?: CancelRailVisitCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(
        cancelRailVisitCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.cancel']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CheckLoadPreparationCommand} [checkLoadPreparationCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkLoadPreparation(
      checkLoadPreparationCommand?: CheckLoadPreparationCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkLoadPreparation(
        checkLoadPreparationCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.checkLoadPreparation']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CheckRailcarForDischargeCommand} [checkRailcarForDischargeCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async checkRailcarForDischarge(
      checkRailcarForDischargeCommand?: CheckRailcarForDischargeCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.checkRailcarForDischarge(
        checkRailcarForDischargeCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.checkRailcarForDischarge']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateRailVisitCommand} [createRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      createRailVisitCommand?: CreateRailVisitCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RailVisitResponseDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(
        createRailVisitCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.create']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateRailcarAndOrdersCommand} [createRailcarAndOrdersCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createRailcarAndOrders(
      createRailcarAndOrdersCommand?: CreateRailcarAndOrdersCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createRailcarAndOrders(
        createRailcarAndOrdersCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.createRailcarAndOrders']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateRailcarTrackPositionCommand} [createRailcarTrackPositionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createRailcarTrackPosition(
      createRailcarTrackPositionCommand?: CreateRailcarTrackPositionCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createRailcarTrackPosition(
        createRailcarTrackPositionCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.createRailcarTrackPosition']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {DeleteRailcarTrackPositionCommand} [deleteRailcarTrackPositionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteRailcarTrackPosition(
      deleteRailcarTrackPositionCommand?: DeleteRailcarTrackPositionCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRailcarTrackPosition(
        deleteRailcarTrackPositionCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.deleteRailcarTrackPosition']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateDepartureCheckRailcarCommand} [createDepartureCheckRailcarCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async departureCheck(
      createDepartureCheckRailcarCommand?: CreateDepartureCheckRailcarCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.departureCheck(
        createDepartureCheckRailcarCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.departureCheck']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} page
     * @param {number} pageSize
     * @param {Array<CarrierVisitStatus>} [statuses]
     * @param {CargoType} [cargoType]
     * @param {boolean} [includeAtaDateRangeFilter]
     * @param {string} [filter]
     * @param {boolean} [includeCompleted]
     * @param {string} [orderBy]
     * @param {boolean} [isDescending]
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      page: number,
      pageSize: number,
      statuses?: Array<CarrierVisitStatus>,
      cargoType?: CargoType,
      includeAtaDateRangeFilter?: boolean,
      filter?: string,
      includeCompleted?: boolean,
      orderBy?: string,
      isDescending?: boolean,
      from?: string,
      to?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<RailVisitResponseDtoPaginatedList>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(
        page,
        pageSize,
        statuses,
        cargoType,
        includeAtaDateRangeFilter,
        filter,
        includeCompleted,
        orderBy,
        isDescending,
        from,
        to,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.get']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getById(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RailVisitResponseDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.getById']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getByIds(
      ids: Array<number>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RailVisitResponseDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getByIds(ids, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.getByIds']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [railVisitId]
     * @param {string} [name]
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getOverlapping(
      railVisitId?: number,
      name?: string,
      from?: string,
      to?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RailVisitResponseDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getOverlapping(
        railVisitId,
        name,
        from,
        to,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.getOverlapping']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateRailVisitCommand} [updateRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async put(
      updateRailVisitCommand?: UpdateRailVisitCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RailVisitResponseDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.put(updateRailVisitCommand, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.put']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {ReactivateRailVisitCommand} [reactivateRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reactivate(
      reactivateRailVisitCommand?: ReactivateRailVisitCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reactivate(
        reactivateRailVisitCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.reactivate']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {ReportRailcarTrackPositionMissingCommand} [reportRailcarTrackPositionMissingCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async reportMissingRailcar(
      reportRailcarTrackPositionMissingCommand?: ReportRailcarTrackPositionMissingCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.reportMissingRailcar(
        reportRailcarTrackPositionMissingCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.reportMissingRailcar']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} id
     * @param {RevertCurrentStatusCommand} [revertCurrentStatusCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async revertCurrentStatus(
      id: number,
      revertCurrentStatusCommand?: RevertCurrentStatusCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.revertCurrentStatus(
        id,
        revertCurrentStatusCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.revertCurrentStatus']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} id
     * @param {UpdateRailVisitStatusCommand} [updateRailVisitStatusCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRailVisitStatus(
      id: number,
      updateRailVisitStatusCommand?: UpdateRailVisitStatusCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRailVisitStatus(
        id,
        updateRailVisitStatusCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.updateRailVisitStatus']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateRailcarSequenceCommand} [updateRailcarSequenceCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateRailcarSequence(
      updateRailcarSequenceCommand?: UpdateRailcarSequenceCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateRailcarSequence(
        updateRailcarSequenceCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['RailVisitsApi.updateRailcarSequence']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * RailVisitsApi - factory interface
 */
export const RailVisitsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = RailVisitsApiFp(configuration)
  return {
    /**
     *
     * @param {AssignRailcarTrackPositionCommand} [assignRailcarTrackPositionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    assignRailcarTrackPosition(
      assignRailcarTrackPositionCommand?: AssignRailcarTrackPositionCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .assignRailcarTrackPosition(assignRailcarTrackPositionCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CancelRailVisitCommand} [cancelRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cancel(
      cancelRailVisitCommand?: CancelRailVisitCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .cancel(cancelRailVisitCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CheckLoadPreparationCommand} [checkLoadPreparationCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkLoadPreparation(
      checkLoadPreparationCommand?: CheckLoadPreparationCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .checkLoadPreparation(checkLoadPreparationCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CheckRailcarForDischargeCommand} [checkRailcarForDischargeCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkRailcarForDischarge(
      checkRailcarForDischargeCommand?: CheckRailcarForDischargeCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .checkRailcarForDischarge(checkRailcarForDischargeCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateRailVisitCommand} [createRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      createRailVisitCommand?: CreateRailVisitCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<RailVisitResponseDto>> {
      return localVarFp
        .create(createRailVisitCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateRailcarAndOrdersCommand} [createRailcarAndOrdersCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRailcarAndOrders(
      createRailcarAndOrdersCommand?: CreateRailcarAndOrdersCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .createRailcarAndOrders(createRailcarAndOrdersCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateRailcarTrackPositionCommand} [createRailcarTrackPositionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createRailcarTrackPosition(
      createRailcarTrackPositionCommand?: CreateRailcarTrackPositionCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .createRailcarTrackPosition(createRailcarTrackPositionCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {DeleteRailcarTrackPositionCommand} [deleteRailcarTrackPositionCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteRailcarTrackPosition(
      deleteRailcarTrackPositionCommand?: DeleteRailcarTrackPositionCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .deleteRailcarTrackPosition(deleteRailcarTrackPositionCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateDepartureCheckRailcarCommand} [createDepartureCheckRailcarCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    departureCheck(
      createDepartureCheckRailcarCommand?: CreateDepartureCheckRailcarCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .departureCheck(createDepartureCheckRailcarCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} page
     * @param {number} pageSize
     * @param {Array<CarrierVisitStatus>} [statuses]
     * @param {CargoType} [cargoType]
     * @param {boolean} [includeAtaDateRangeFilter]
     * @param {string} [filter]
     * @param {boolean} [includeCompleted]
     * @param {string} [orderBy]
     * @param {boolean} [isDescending]
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(
      page: number,
      pageSize: number,
      statuses?: Array<CarrierVisitStatus>,
      cargoType?: CargoType,
      includeAtaDateRangeFilter?: boolean,
      filter?: string,
      includeCompleted?: boolean,
      orderBy?: string,
      isDescending?: boolean,
      from?: string,
      to?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<RailVisitResponseDtoPaginatedList> {
      return localVarFp
        .get(
          page,
          pageSize,
          statuses,
          cargoType,
          includeAtaDateRangeFilter,
          filter,
          includeCompleted,
          orderBy,
          isDescending,
          from,
          to,
          options,
        )
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<RailVisitResponseDto> {
      return localVarFp.getById(id, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {Array<number>} ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getByIds(
      ids: Array<number>,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<RailVisitResponseDto>> {
      return localVarFp.getByIds(ids, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [railVisitId]
     * @param {string} [name]
     * @param {string} [from]
     * @param {string} [to]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getOverlapping(
      railVisitId?: number,
      name?: string,
      from?: string,
      to?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<RailVisitResponseDto> {
      return localVarFp
        .getOverlapping(railVisitId, name, from, to, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateRailVisitCommand} [updateRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    put(
      updateRailVisitCommand?: UpdateRailVisitCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<RailVisitResponseDto> {
      return localVarFp
        .put(updateRailVisitCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {ReactivateRailVisitCommand} [reactivateRailVisitCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reactivate(
      reactivateRailVisitCommand?: ReactivateRailVisitCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .reactivate(reactivateRailVisitCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {ReportRailcarTrackPositionMissingCommand} [reportRailcarTrackPositionMissingCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    reportMissingRailcar(
      reportRailcarTrackPositionMissingCommand?: ReportRailcarTrackPositionMissingCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .reportMissingRailcar(reportRailcarTrackPositionMissingCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} id
     * @param {RevertCurrentStatusCommand} [revertCurrentStatusCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    revertCurrentStatus(
      id: number,
      revertCurrentStatusCommand?: RevertCurrentStatusCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .revertCurrentStatus(id, revertCurrentStatusCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} id
     * @param {UpdateRailVisitStatusCommand} [updateRailVisitStatusCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRailVisitStatus(
      id: number,
      updateRailVisitStatusCommand?: UpdateRailVisitStatusCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .updateRailVisitStatus(id, updateRailVisitStatusCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateRailcarSequenceCommand} [updateRailcarSequenceCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateRailcarSequence(
      updateRailcarSequenceCommand?: UpdateRailcarSequenceCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updateRailcarSequence(updateRailcarSequenceCommand, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * RailVisitsApi - object-oriented interface
 */
export class RailVisitsApi extends BaseAPI {
  /**
   *
   * @param {AssignRailcarTrackPositionCommand} [assignRailcarTrackPositionCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public assignRailcarTrackPosition(
    assignRailcarTrackPositionCommand?: AssignRailcarTrackPositionCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .assignRailcarTrackPosition(assignRailcarTrackPositionCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CancelRailVisitCommand} [cancelRailVisitCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public cancel(cancelRailVisitCommand?: CancelRailVisitCommand, options?: RawAxiosRequestConfig) {
    return RailVisitsApiFp(this.configuration)
      .cancel(cancelRailVisitCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CheckLoadPreparationCommand} [checkLoadPreparationCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public checkLoadPreparation(
    checkLoadPreparationCommand?: CheckLoadPreparationCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .checkLoadPreparation(checkLoadPreparationCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CheckRailcarForDischargeCommand} [checkRailcarForDischargeCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public checkRailcarForDischarge(
    checkRailcarForDischargeCommand?: CheckRailcarForDischargeCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .checkRailcarForDischarge(checkRailcarForDischargeCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateRailVisitCommand} [createRailVisitCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public create(createRailVisitCommand?: CreateRailVisitCommand, options?: RawAxiosRequestConfig) {
    return RailVisitsApiFp(this.configuration)
      .create(createRailVisitCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateRailcarAndOrdersCommand} [createRailcarAndOrdersCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createRailcarAndOrders(
    createRailcarAndOrdersCommand?: CreateRailcarAndOrdersCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .createRailcarAndOrders(createRailcarAndOrdersCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateRailcarTrackPositionCommand} [createRailcarTrackPositionCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public createRailcarTrackPosition(
    createRailcarTrackPositionCommand?: CreateRailcarTrackPositionCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .createRailcarTrackPosition(createRailcarTrackPositionCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {DeleteRailcarTrackPositionCommand} [deleteRailcarTrackPositionCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public deleteRailcarTrackPosition(
    deleteRailcarTrackPositionCommand?: DeleteRailcarTrackPositionCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .deleteRailcarTrackPosition(deleteRailcarTrackPositionCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateDepartureCheckRailcarCommand} [createDepartureCheckRailcarCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public departureCheck(
    createDepartureCheckRailcarCommand?: CreateDepartureCheckRailcarCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .departureCheck(createDepartureCheckRailcarCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} page
   * @param {number} pageSize
   * @param {Array<CarrierVisitStatus>} [statuses]
   * @param {CargoType} [cargoType]
   * @param {boolean} [includeAtaDateRangeFilter]
   * @param {string} [filter]
   * @param {boolean} [includeCompleted]
   * @param {string} [orderBy]
   * @param {boolean} [isDescending]
   * @param {string} [from]
   * @param {string} [to]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(
    page: number,
    pageSize: number,
    statuses?: Array<CarrierVisitStatus>,
    cargoType?: CargoType,
    includeAtaDateRangeFilter?: boolean,
    filter?: string,
    includeCompleted?: boolean,
    orderBy?: string,
    isDescending?: boolean,
    from?: string,
    to?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .get(
        page,
        pageSize,
        statuses,
        cargoType,
        includeAtaDateRangeFilter,
        filter,
        includeCompleted,
        orderBy,
        isDescending,
        from,
        to,
        options,
      )
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getById(id: number, options?: RawAxiosRequestConfig) {
    return RailVisitsApiFp(this.configuration)
      .getById(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {Array<number>} ids
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getByIds(ids: Array<number>, options?: RawAxiosRequestConfig) {
    return RailVisitsApiFp(this.configuration)
      .getByIds(ids, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [railVisitId]
   * @param {string} [name]
   * @param {string} [from]
   * @param {string} [to]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RailVisitsApi
   */
  public getOverlapping(
    railVisitId?: number,
    name?: string,
    from?: string,
    to?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .getOverlapping(railVisitId, name, from, to, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateRailVisitCommand} [updateRailVisitCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public put(updateRailVisitCommand?: UpdateRailVisitCommand, options?: RawAxiosRequestConfig) {
    return RailVisitsApiFp(this.configuration)
      .put(updateRailVisitCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {ReactivateRailVisitCommand} [reactivateRailVisitCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public reactivate(
    reactivateRailVisitCommand?: ReactivateRailVisitCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .reactivate(reactivateRailVisitCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {ReportRailcarTrackPositionMissingCommand} [reportRailcarTrackPositionMissingCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public reportMissingRailcar(
    reportRailcarTrackPositionMissingCommand?: ReportRailcarTrackPositionMissingCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .reportMissingRailcar(reportRailcarTrackPositionMissingCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} id
   * @param {RevertCurrentStatusCommand} [revertCurrentStatusCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public revertCurrentStatus(
    id: number,
    revertCurrentStatusCommand?: RevertCurrentStatusCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .revertCurrentStatus(id, revertCurrentStatusCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} id
   * @param {UpdateRailVisitStatusCommand} [updateRailVisitStatusCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateRailVisitStatus(
    id: number,
    updateRailVisitStatusCommand?: UpdateRailVisitStatusCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .updateRailVisitStatus(id, updateRailVisitStatusCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateRailcarSequenceCommand} [updateRailcarSequenceCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateRailcarSequence(
    updateRailcarSequenceCommand?: UpdateRailcarSequenceCommand,
    options?: RawAxiosRequestConfig,
  ) {
    return RailVisitsApiFp(this.configuration)
      .updateRailcarSequence(updateRailcarSequenceCommand, options)
      .then(request => request(this.axios, this.basePath))
  }
}
